export class GetFinalizedReturnRequestQuery {
    private readonly _warehouseCode: string;

    constructor(warehouseCode: string) {
        this._warehouseCode = warehouseCode;
    }

    get warehouseCode(): string {
        return this._warehouseCode;
    }
}
